import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
import { setUser as i } from "/home/runner/work/oko-web/oko-web/node_modules/@sentry/react/build/esm/index.js";
//#region src/lib/stores/session-store/useSessionStore.ts
var a = t(r((e, t) => {
	function n(n) {
		if (typeof n == "boolean") {
			e({ isServiceOnline: n });
			return;
		}
		e({ isServiceOnline: n(t().isServiceOnline) });
	}
	return {
		userProfile: void 0,
		userSettings: void 0,
		isGuest: !1,
		isSignInFromGuestMode: !1,
		guestTermsConfirmed: !1,
		isServiceOnline: !0,
		setUserProfile: (t) => {
			i({
				id: t.id,
				email: t.email
			}), e({ userProfile: t });
		},
		setUserSettings: (t) => {
			e({ userSettings: t });
		},
		clearUserProfile: () => e({ userProfile: void 0 }),
		clearUserSettings: () => e({ userSettings: void 0 }),
		setIsGuest: (t) => e({ isGuest: t }),
		setGuestTermsConfirmed: (t) => e({ guestTermsConfirmed: t }),
		setIsServiceOnline: n,
		setIsSignInFromGuestMode: (t) => e({ isSignInFromGuestMode: t }),
		getIsSignInFromGuestMode: () => t().isSignInFromGuestMode
	};
})), o = (t) => e(a, n(t));
//#endregion
export { a as sessionStore, o as useSessionStore };
